module.exports = __webpack_public_path__ + "static/media/Vehicle Tracking.54cf08fd.png";